import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@wfp-common/auth/AuthContext';

import { ManagerPermission } from '../../permission-profiles/permission';

interface PermissionCheckerProps {
    requiredPermissions: ManagerPermission[];
    children?: React.ReactNode;
}

export const PermissionChecker: FC<PermissionCheckerProps> = (props) => {
    const { loggedUser, appHomePath } = useAuthContext();

    if (loggedUser && !loggedUser.hasPermissions(props.requiredPermissions)) {
        return <Navigate to={appHomePath} />;
    }

    return <>{props.children}</>;
};
